import * as React from 'react';
import { Link } from 'gatsby';

const Header = ({ location }) => {
  return (
    <div className='nav' id='header'>
      {location !== '/' ? (
        <div className='navLink'>
          <Link to='/#header' activeClassName='active'>
            Inici
          </Link>
        </div>
      ) : (
        ''
      )}
      {location !== '/exposicions' ? (
        <div className='navLink'>
          <Link to='/exposicions' activeClassName='active'>
            Exposicions
          </Link>
        </div>
      ) : (
        ''
      )}

      {location !== '/eugeni-prieto-texts' ? (
        <div className='navLink'>
          <Link to='/eugeni-prieto-text' activeClassName='active'>
            Eugeni Prieto
          </Link>
        </div>
      ) : (
        ''
      )}

      {location !== '/pau-guerrero-text' ? (
        <div className='navLink'>
          <Link to='/pau-guerrero-text' activeClassName='active'>
            Pau Guerrero
          </Link>
        </div>
      ) : (
        ''
      )}

      {location !== '/contacte' ? (
        <div className='navLink'>
          <Link to='/contacte' activeClassName='active'>
            Contacte
          </Link>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Header;
